<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base :busy="loadingArticle">
        <template v-slot:default="props">
            <pb-body :breadcrumbs="breadcrumbs">
                <template slot="body">
                    <b-container>
                        <b-row v-if="!user">
                            <b-col>
                                <b-alert variant="warning" show>Area restricted for registered users only.
                                    Please login or
                                    register in order to proceed.
                                </b-alert>
                            </b-col>
                        </b-row>
                        <b-row v-else-if="apiError">
                            <b-col>
                                <b-alert variant="warning" show>{{apiError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row v-else-if="article && !loadingArticle">
                            <b-col md="6">
                                <ImageGallery ref="gallery" :images="imageList"/>
                            </b-col>
                            <b-col v-if="isApproved" md="6">
                                <h3 class="text-center my-3">{{article.primaryDescription ||
                                    article.secondaryDescription}}</h3>
                                <div class="info-box d-block">
                                    <b-row>
                                        <b-col class="text-right">
                                            <b>item number</b>
                                        </b-col>
                                        <b-col class="text-left">
                                            <b-row>
                                                <b-col>
                                                    {{article.name}}
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row class="mt-2">
                                    <b-col>
                                        <pb-article-details-table
                                                :article="article"></pb-article-details-table>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col v-bind:class="[{ busy: loadingVariantList}, 'opacity-transition']">
                                        <pb-spinner v-if="loadingVariantList"></pb-spinner>
                                        <custom-select class="border-bottom border-top border-secondary"
                                                       @select="onSelectColor"
                                                       :value="selectedColor" label="COLOR"
                                                       :key="selectedColor"
                                                       inline-label="Color:"
                                                       :options="colorOptions">
                                            <template slot="prefix">
                                                <div v-if="showSelectCustomerModeSwitch"
                                                     title="Customer Color Names"
                                                     style="position: absolute; left: 5px; font-size: 20px;"
                                                     @click.stop="toggleColorSelectMode">
                                                    <i v-if="colorSelectCustomerMode"
                                                       class="fal fa-toggle-on"></i>
                                                    <i v-else class="fal fa-toggle-off"></i>
                                                </div>
                                            </template>
                                        </custom-select>
                                        <div v-if="selectedColorVariants.length > 0">
                                            <b-table class="table-striped"
                                                     style="font-size: 13px;"
                                                     :items="selectedColorVariants"
                                                     :fields="[{key: 'articleSize', label: 'Size'}, {key: 'weight', label: 'Weight'}, {key: 'sampleThresholdPrice', label: 'From ' + article.sampleThreshold}, {key: 'bulkpriceThreshold', label: 'From ' + article.bulkpriceThreshold}, {key: 'stock', label: 'Stock'}]">
                                                <template #cell(articleSize)="data">
                                                    <b>{{ data.value.value }}</b>
                                                </template>
                                                <template #cell(weight)="data">
                                                    <span v-if="data.value > 0">{{ data.value }}  g/{{article.priceUnit}}</span>
                                                    <span v-else>-</span>
                                                </template>
                                                <template #cell(sampleThresholdPrice)="data">
                                                <span v-if="data.item.articlePrice && data.item.articlePrice.samplePrice > 0">

                                                    {{data.item.articlePrice.samplePrice | currency($currencyFormatting[data.item.articlePrice.currency])}}
                                                     <span v-if="user.externalAccountType === 'DIAMOND' && user && user.pricingInAllCurrencies && data.item.articlePrice.samplePriceForeignCurrency > 0"><br/>{{ data.item.articlePrice.samplePriceForeignCurrency |
                                            currency($currencyFormatting[data.item.articlePrice.currencyCodeForeignCurrency])}}</span>
                                                </span>
                                                    <pb-btn v-else-if="!requestedPriceMap.has(data.item.articleColor.id)"
                                                            :busy="requestingPrice"
                                                            icon="fa-euro-sign" block
                                                            v-on:click.native="requestPrice()"
                                                            size="sm"
                                                            variant="secondary">
                                                        Request Price
                                                    </pb-btn>
                                                    <span class="my-2 d-block text-success" v-else><i
                                                            class="fal fa-check"></i>&nbsp;Price Requested</span>
                                                </template>
                                                <template #cell(bulkpriceThreshold)="data">
                                                    <span v-if="data.item.articlePrice && data.item.articlePrice.price > 0">
                                                        {{data.item.articlePrice.price | currency($currencyFormatting[data.item.articlePrice.currency])}}
                                                    <span v-if="user.externalAccountType === 'DIAMOND' && user && user.pricingInAllCurrencies && data.item.articlePrice.priceForeignCurrency > 0"><br/>{{ data.item.articlePrice.priceForeignCurrency |
                                            currency($currencyFormatting[data.item.articlePrice.currencyCodeForeignCurrency])}}</span>
                                                    </span>

                                                    <pb-btn v-else-if="!requestedPriceMap.has(data.item.articleColor.id)"
                                                            :busy="requestingPrice"
                                                            icon="fa-euro-sign" block
                                                            v-on:click.native="requestPrice()"
                                                            size="sm"
                                                            variant="secondary">
                                                        Request Price
                                                    </pb-btn>
                                                    <span class="my-2 d-block text-success" v-else><i
                                                            class="fal fa-check"></i>&nbsp;Price Requested</span>
                                                </template>
                                                <template #cell(stock)="data">
                                                            <span v-if="data.item.articlePrice">
                                                                {{data.item.articlePrice.calculatedStock}}
                                                            </span>
                                                    <span v-else>-</span>
                                                </template>
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row class="mt-2">
                                    <b-col md="4" id="popover-button-event">
                                        <pb-btn :busy="loadingExport" href="#" class="d-block mb-2"
                                                :disabled="!selectedColor"
                                                icon="fa-file-pdf"
                                                v-on:click.native="loadArticlePdf()"
                                                size="lg"
                                                variant="primary">
                                            Download Details
                                        </pb-btn>
                                    </b-col>
                                    <b-col md="4">
                                        <pb-btn :busy="loadingEmail" href="#" class="d-block mb-2"
                                                :disabled="!selectedColor"
                                                icon="fa-envelope"
                                                v-on:click.native="sendArticlePdf()"
                                                size="lg"
                                                variant="primary">
                                            Email Details
                                        </pb-btn>
                                    </b-col>
                                    <b-col md="4">
                                        <div id="btn-shop">
                                            <pb-btn :busy="loadingShopArticle" class="d-block mb-2"
                                                    :disabled="!articleAvailableInShop || loadingShopArticle"
                                                    icon="fa-shopping-cart"
                                                    :to="{ name: 'ar', params: {articleId: article.id}}"
                                                    size="lg"
                                                    variant="secondary">
                                                View in Shop
                                            </pb-btn>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-popover v-if="!selectedColor" triggers="hover"
                                           target="popover-button-event"
                                           variant="warning"
                                           placement="top">
                                    <span>
                                        Please select the article color first.
                                    </span>
                                </b-popover>
                                <b-popover v-if="!articleAvailableInShop" triggers="hover" target="btn-shop"
                                           variant="warning"
                                           placement="top">
                                    <span>
                                        Article is currently not available.
                                    </span>
                                </b-popover>
                            </b-col>
                            <b-col v-else md="6">
                                <h3 class="text-center my-3">{{article.primaryDescription ||
                                    article.secondaryDescription}}</h3>
                                <div class="info-box d-block">
                                    <b-row>
                                        <b-col class="text-right">
                                            <b>item number</b>
                                        </b-col>
                                        <b-col class="text-left">
                                            <b-row>
                                                <b-col>
                                                    {{article.name}}
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="my-4 text-center">
                                            article details are currently getting created
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="text-center">
                                            <pb-btn v-b-modal.contactModal class="text-center mb-2"
                                                    @click.native="$refs.contactModal.resetData()"
                                                    icon="fa-envelope"
                                                    variant="secondary">
                                                REQUEST MORE INFORMATION
                                            </pb-btn>
                                        </b-col>
                                    </b-row>
                                    <contact-modal
                                            ref="contactModal"
                                            id="contactModal"
                                            :article="article"
                                            :subject="contactSubject">
                                    </contact-modal>
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>

                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>
<script>
    import {mapActions, mapState} from "vuex";
    import ArticleDetailsTable from "../../components/article/ArticleDetailsTable";
    import ArticleApi from "@shared/_api/article";
    import ArticleBase from "./ArticleBase";
    import CustomSelect from "../../components/ui/CustomSelect";
    import ImageGallery from "../../components/ImageGallery";
    import ContactModal from "../../components/ui/ContactModal";

    export default {
        name: 'pb-article-basic',
        extends: ArticleBase,
        data() {
            return {
                loadingArticle: false,
                loadingExport: false,
                loadingEmail: false,
                loadingShopArticle: false,
                requestingPrice: false,
                requestedPriceMap: new Map(),
                articleAvailableInShop: true,
                article: null,
                apiError: null,
                breadcrumbs: [{
                    text: 'QR',
                    href: '#'
                }]
            }
        },
        components: {
            'pb-article-details-table': ArticleDetailsTable,
            'contact-modal': ContactModal,
            'custom-select': CustomSelect,
            'ImageGallery': ImageGallery
        },
        mounted() {
            this.loadArticleData(this.$route.params.articleId);
        },
        beforeRouteUpdate(to, from, next) {
            this.loadArticleData(to.params.articleId);
            next();
        },
        methods: {
            ...mapActions('cart', ['addItem', 'fetchCart']),
            ...mapActions('favorites', ['addFavorite']),
            requestPrice() {
                this.requestingPrice = true;
                ArticleApi.requestPrice(this.article.id, this.selectedColor).then(() => {
                    this.requestedPriceMap.set(this.selectedColor, true);
                    this.$bvToast.toast(`Price request was successfully sent.`, this.$toastSuccess)
                }).finally(() => {
                    this.requestingPrice = false;
                    this.$tracker.trackEvent({
                        label: 'price_request_qr',
                        meta: this.article.name + ";" + this.article.id,
                        type: 'PRICE_REQUEST_QR'
                    });
                })
            },
            sendArticlePdf() {
                this.loadingEmail = true;
                ArticleApi.emailBasicPdf(this.article.id, this.selectedColor).then(() => {
                    this.$bvToast.toast(`Email was successfully sent.`, this.$toastSuccess)
                }).finally(() => {
                    this.loadingEmail = false;
                })
            },
            loadPricing(articleId, colorId) {
                this.loadingVariantList = true;
                return ArticleApi.customerArticleBasic(articleId, colorId).then(article => {
                    let result = [],
                        map = new Map();

                    for (const variant of article.variantList) {
                        let variantId = variant.variationId;

                        if (!map.has(variantId)) {
                            map.set(variantId, true);
                            result[variantId] = variant.articlePrice
                        }
                    }

                    for (const variant of this.variantList) {
                        if (!variant.articlePrice) {
                            this.$set(variant, "articlePrice", result[variant.variationId]);
                        }
                    }

                }).finally(() => {
                    this.loadingVariantList = false;
                })
            },
            loadArticlePdf() {
                this.loadingExport = true;
                ArticleApi.basicPdf(this.article.id, this.selectedColor).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.article.name + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                }).finally(() => {
                    this.loadingExport = false;
                    this.$tracker.trackEvent({
                        label: 'download',
                        meta: this.article.name + ";" + this.article.id,
                        type: 'DOWNLOAD_ARTICLE_DETAILS_PDF'
                    });
                })
            },
            isSampleRequestEnabled() {
                return this.user && this.user.externalData && (this.user.externalData.customerCategory === 'A' || this.user.externalData.customerCategory === 'B') || this.hasRole('Admin');
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            toggleDetails() {
                this.stockVisible = false;
            },
            onSelectColor(colorOptionValue) {
                this.selectedColor = Number(colorOptionValue);
            },
            loadArticleData(articleId) {
                this.category = null;
                this.apiError = null;
                this.loadingArticle = true;
                this.loadingShopArticle = true;

                this.loadArticleStub(articleId).catch(error => {
                    if (error.status === 403 || error.status === 404) {
                        this.articleAvailableInShop = false;
                    }
                }).finally(() => {
                    this.loadingShopArticle = false;
                });

                return ArticleApi.customerArticleBasicStub(articleId).then((article) => {
                    this.$tracker.trackView({label: article.name, type: 'ARTICLE_DETAIL_QR'}, this.user);
                    this.article = article;
                }).catch(error => {
                    if (error.status === 403) {
                        this.apiError = "Access is denied. You may not have the appropriate permissions to access the requested product data."
                    } else if (error.status === 404) {
                        this.apiError = "We could not find the requested article"
                    } else {
                        this.apiError = error;
                    }
                }).finally(() => {
                    this.loadingArticle = false;
                })
            }
        },
        computed: {
            ...mapState("account", ['user']),
            selectedColorVariants() {
                if (this.selectedColor) {
                    return this.variantList.filter(variant => variant.articleColor.id === this.selectedColor);
                }
                return [];
            },
            articleDetails() {
                return this.article;
            },
            imageList: function () {
                let defaultImageList = this.defaultImages.concat(this.article.cardImg && this.user ? [{media: this.article.cardImg}] : []);

                if (defaultImageList.length === 0) {
                    defaultImageList = [{image: this.article.image}]
                }
                let defaultIndex = (this.variantImages && this.variantImages.length > 0) ? defaultImageList.length : 0;
                return defaultImageList.concat(this.variantImages).map((img, index) => {
                    return {src: this.baseUrl + img.media, isDefault: index === Number(defaultIndex)};
                });
            },
            rawComponents: function () {
                return (this.articlePrice.rawComponents > 0) ? this.articlePrice.stock : 0;
            }
        },
        watch: {
            user: function () {
                this.loadArticleData(this.$route.params.articleId);
            },
            selectedColor: function (colorId) {
                if (colorId) {
                    this.loadPricing(this.article.id, colorId);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .article-row {
        margin-top: 120px;
        @include media-breakpoint-down(md) {
            margin-top: 60px;
        }
    }

    .article-stock-collapsible {
        overflow-x: auto;
    }

    .article-details {
        .article-info {
            position: relative;

        }

        .article-details-toggle-btn {
            .when-opened {
                display: none;
            }

            .when-closed {
                display: inline-block;
            }

            &.collapsed {
                .when-opened {
                    display: inline-block;
                }

                .when-closed {
                    display: none;
                }
            }
        }

        .article-document-section {
            a {
                text-transform: uppercase;
            }
        }

        .info-block {
            font-size: 15px;
            letter-spacing: 1.5px;
            font-family: $font-muli;
            color: $color-primary-dark;
        }

        .price-block {
            font-size: 18px;
            letter-spacing: 1.5px;
            font-family: $font-muli;
            color: $color-primary
        }


    }
</style>